var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-5,.cls-7{fill:none;stroke-miterlimit:10;stroke-width:5px;stroke-dasharray:12 12;}.cls-1{stroke:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{stroke:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{stroke:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{stroke:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1179.07,
    y1: 1451.59,
    x2: 1273.48,
    y2: 1451.85,
    gradientTransform: "matrix(-0.2, -1.03, -0.68, 0.13, 1867.74, 1290.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac68e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a1aac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1184.92,
    y1: 1234.74,
    x2: 1271.03,
    y2: 1234.99,
    gradientTransform: "matrix(-0.19, -0.98, -0.98, 0.19, 2105.27, 1184.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 890.17,
    y1: 1454.38,
    x2: 984.58,
    y2: 1454.65,
    gradientTransform: "matrix(-0.21, -1.09, -1.04, 0.2, 2247.38, 1267.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 884.22,
    y1: 1376.71,
    x2: 970.33,
    y2: 1376.96,
    gradientTransform: "matrix(-0.19, -0.98, -0.98, 0.19, 2105.27, 1184.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 749.3,
    y1: 1130.03,
    x2: 843.71,
    y2: 1130.29,
    gradientTransform: "matrix(-0.75, -1.12, 1.3, -0.87, -442.83, 2660.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 767.68,
    y1: 921.56,
    x2: 853.8,
    y2: 921.81,
    gradientTransform: "translate(66.76 2010.98) rotate(-123.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 934.3,
    y1: 1075.7,
    x2: 1028.71,
    y2: 1075.96,
    gradientTransform: "matrix(0.5, -2.06, 1.69, 0.41, -1840.9, 1972.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 882.83,
    y1: 819.85,
    x2: 968.95,
    y2: 820.1,
    gradientTransform: "translate(-616.16 1115.57) rotate(-76.22)",
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.15,169.69c9.55,4.82,44.41-.55,67.55,61.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M673,250.88c-6-8.21-15-17.93-23.14-23.23l16.91,1.2L680.54,219C676.42,227.75,673.81,240.75,673,250.88Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M487.87,493.18c14,4.32,67.1-4.45,96.62,60.13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.81,572.83c-6-8.2-15-17.92-23.15-23.23l16.91,1.21,13.77-9.89C593.22,549.7,590.61,562.71,589.81,572.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M391.33,843.47c-26.1-83.58,38.89-129.2,50.07-146.78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.48,843.7,390.22,841,401.4,828.3c-2,9.49-1.63,22.74-.12,32.79C393.59,854.45,382.59,847,373.48,843.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M394.39,433.67C452.75,312.41,539.17,331,562.93,323.34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M382.2,420.63l13.24,10.59,16.95-.31c-8.4,4.87-17.92,14.1-24.33,22C387.79,442.74,385.86,429.61,382.2,420.63Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileArrows);
export default __webpack_public_path__ + "static/media/mobileArrows.d712a882be8790cc98a36a081b08bc64.svg";
export { ForwardRef as ReactComponent };